export default __webpack_public_path__ + "static/media/user.571faac8.png";